<template>
  <div class="pannel04">
    <div style="border-bottom:1px solid #ccc;font:700 12px/40px 'simsun';padding-left: 10px">热门搜索</div>
    <div class="content1" style="font-size: 14px;">
      <div class="pannel01">
        <span style="color: #929292">&emsp;搜索用户数: </span><br>
        <span style="font-size: 18px;color: #5a5a5a;">&emsp; {{search_user_count}} &emsp;&emsp; <span style="font-size: 14px">{{(search_user_count/user_count*100).toFixed(2)}}%</span></span>
        <!-- <div id="curve_show1" class="curve_show1"></div> -->
      </div>
      <div class="pannel02">
        <span style="color: #929292">&emsp;人均搜索次数: </span><br>
        <span style="font-size: 18px;color: #5a5a5a;">&emsp; {{(count/search_user_count).toFixed(2)}}</span>
        <!-- <div id="curve_show2" class="curve_show2"></div> -->
      </div>
    </div>

    <div class="content2">
      <SearchTable :channels="aSearchList" :nowPage='page' @fnResetTable="fnGetData"></SearchTable>
      <el-pagination
        background
        layout="prev, pager, next"
        :page-count="pages"
        :current-page="page"
        style="text-align:center;margin-top:10px"
        @current-change="fnGetPage"
        >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import cons from '@/components/constant'
import SearchTable from '@/components/widget/SearchTable'
export default {
  name: 'PieGraph',
  data () {
    return {
      page:1,
      pages:8,
      pagesize:10,
      search_user_count: 0, // 搜索用户数
      user_count: 0, // 总用户数
      count: 0,
      msg: 'Welcome to Your Vue.js App',
      aSearchList: []
    }
  },
  components:{
    SearchTable
  },
  mounted(){
    let token = localStorage.token;

    // 获取月  网站访问量
    this.axios.get(cons.apis + '/v1_0/statistics_search_total', {
        headers: {
          'Authorization': 'Bearer ' + token
        },
        responseType: 'json'
    })
    .then(dat=>{
      // console.log(dat)
      this.search_user_count = dat.data.data.search_user_count // 搜索用户数
      this.user_count = dat.data.data.search_user_count // 总用户数
      this.count = dat.data.data.search_user_count

    }).catch(err=>{
       console.log(err);
    });


    // // 获取月  人均搜索次数
    // this.axios.get(cons.apis + '/v1_0/statistics_basic', {
    //     headers: {
    //       'Authorization': 'Bearer ' + token
    //     },
    //     responseType: 'json',
    //     params:{
    //       type: 'access',
    //       size: 'month'
    //     }
    // })
    // .then(dat=>{
    //     let aList_all = dat.data.data;
    //     let aCount = [];
    //     let aDate = [];

    //     for(var i=0;i<aList_all.length;i++){
    //         aCount.push(aList_all[i].count);
    //         // aDate.push(aList_all[i].date);
    //         aDate.push(aList_all[i].month);
    //     }
    //     aCount = [12, 4, 6, 44, 42, 33, 45, 76, 23, 46, 4, 3]

    //     let oCurve = this.echarts.init(document.getElementById('curve_show2'));
    //     let oCurveopt =
    //             {
    //               title:{
    //                   text: '人均搜索次数',
    //                   left: 'right',
    //                   top: '10'
    //               },
    //               tooltip:{
    //                   trigger: 'axis'
    //               },
    //               // legend: {
    //               //     data:['active'],
    //               //     top: '40'
    //               // },
    //               // toolbox: {
    //               //     show : false,
    //               //     feature : {
    //               //         mark : {show: true},
    //               //         dataView : {show: true, readOnly: false},
    //               //         magicType : {show: true, type: ['line','bar']},
    //               //         restore : {show: true},
    //               //         saveAsImage : {show: true}
    //               //     }
    //               // },
    //               calculable : true,
    //               xAxis : [
    //                   {
    //                       name: '月份',
    //                       type : 'category',
    //                       boundaryGap : false,
    //                       data : aDate
    //                   }
    //               ],
    //               yAxis : [
    //                   {
    //                       name: '',
    //                       type : 'value'
    //                   }
    //               ],
    //               series : [
    //                   {
    //                       name:'active',
    //                       type:'line',
    //                       smooth:true,
    //                       lineStyle: {color: '#f80'},
    //                       data:aCount,
    //                       areaStyle:{
    //                         normal:{
    //                             color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [{
    //                                 offset: 0,
    //                                 color: 'rgba(255,136,0,0.39)'
    //                             }, {
    //                                 offset: 0.34,
    //                                 color: 'rgba(255,180,0,0.25)'
    //                             },{
    //                                 offset: 1,
    //                                 color: 'rgba(255,222,0,0.00)'
    //                             }])
    //                         }
    //                     }
    //               }],
    //               grid: {
    //                   show: true,
    //                   x:30,
    //                   x2:15,
    //                   y:40,
    //                   height:60
    //               }

    //             };
    //     oCurve.setOption(oCurveopt);


    // }).catch(err=>{
    //    console.log(err);
    // });


    this.fnGetData(1)
  },
  methods:{
    fnGetData:function(num){
      let token = localStorage.token;
      this.axios.get(cons.apis + '/v1_0/statistics_search', {
          headers: {
            'Authorization': 'Bearer ' + token
          },
          responseType: 'json',
          params:{
            page:num,
            per_page:this.pagesize
          }
      })
      .then(dat=>{
          this.aSearchList = dat.data.data.keywords;
          this.page = num;
          this.pages = dat.data.data.total_count;
      }).catch(err=>{
         console.log(err);
      });
    },
    fnGetPage:function(dat){
      this.page = dat;
      this.fnGetData(this.page);
    }
  }
}
</script>

<style scoped>
.pannel04{
  width:46.3%;
  height:800px;
  margin:20px auto 0;
  background-color:#fff;
  float:left;
  margin-left:2.4%;
}
.pie_show4{
  width:100%;
  height:350px;
}
.pannel01, .pannel02 {
  width: 49%;
  float: left;
  overflow:hidden;
  background-color:#fff;
  padding: 2px;
}
.curve_show1,.curve_show2 {
  width:260px;
  height:130px;
  /*background: #eee;*/
}
.content1 {
  padding: 10px 0;
  overflow: hidden;
}
.content2 {
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/widget/PieGraph.vue